import { useTranslation } from "react-i18next";
import MainArea from "../../../components/UI/MainArea";
import PositionMicropiles from "./PositionMicropiles/PositionMicropiles";
import PositionTestLoads from "./PositionTestLoads/PositionTestLoads";
import PositionPileheads from "./PositionPileheads/PositionPileheads";
import PositionRequirements from "./PositionRequirements/PositionRequirements";

export default function LVText() {
  const { t } = useTranslation("translation");

  return (
    <MainArea className="container">
      <div className="row">
        <br />
        <h1 className="mainheadline">{t("lvText.mainheadline")}</h1>
      </div>
      <br />
      <PositionMicropiles />
      <PositionPileheads />
      <PositionTestLoads />
      <PositionRequirements />
    </MainArea>
  );
}
